import { useState } from 'react'
import '../css/Match.css'
import MatchInfo from './MatchInfo';
import Backdrop from './Backdrop';
import { useAuth } from "../contexts/AuthContext"
import { db } from '../firebase'
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';

function Match(props) {


    const [matchInfoIsOpen, setMatchInfoIsOpen] = useState(false);
    const { currentUser } = useAuth();

    function handleMatchInfo() {
        setMatchInfoIsOpen(true);
    }

    function hadleCloseMatchInfo() {
        setMatchInfoIsOpen(false);
    }

    function handleFavorite() {
        if (props.isFavorite === true) {
            db.collection("Players").doc(`${currentUser.uid}`).collection("Favorites").doc(`${props.id}`)
                .delete().then(() => {
                    console.log("Fixture successfully deleted!");
                    window.location.reload(true);
                }).catch((error) => {
                    console.error("Error removing Fixture", error);
                });
        } else if
            (props.isFavorite === false) {
            db.collection("Players").doc(`${currentUser.uid}`).collection("Favorites").doc(`${props.id}`)
                .set({
                    id: props.id,
                    teams: props.teams,
                    logoLocalTeam: props.logoLocalTeam,
                    logoVisitorTeam: props.logoVisitorTeam,
                    dateAndTime: props.dateAndTime,
                    date: props.date,
                    time: props.time,
                    localTeam: props.localTeam,
                    localTeamId: props.localTeamId,
                    visitorTeam: props.visitorTeam,
                    visitorTeamId: props.visitorTeamId,
                    timestamp: props.timestamp,
                    league: props.league,
                    predictionLocal: props.predictionLocal,
                    predictionVisitor: props.predictionVisitor,
                    predictionDraw: props.predictionDraw,
                    isFavorite: true,
                    winnerTeamId: null,
                    isProcessed: false,
                    score: props.score
                })
                .then(() => {
                    console.log("Document successfully written!");
                    window.location.reload(true);
                })
                .catch((error) => {
                    console.error("Error writing document: ", error);
                });
        }

    }

    return (
        <div className="card me-4 bg-dark text-center" id='card-match' >
            <div className="row card-header verticalAlign">
                <div className="col-md-4">
                    <p className="">{props.date} {props.time}</p>
                </div>
                <div className="col-md-4">
                    <h6 className="">{props.teams} <br /> {props.league}</h6>
                </div>
                <div className="col-md-1 offset-md-3">
                    <button id="test" className="btn btn-dark" onClick={handleFavorite}>
                        {props.isFavorite ? <Star/> : <StarBorder/>}
                    </button>
                </div>
            </div>
            <div className="card-body row verticalAlign">
                <div className="col-md-4">
                    <img src={props.logoLocalTeam} alt="football_team_local" width="60" height="60" />
                </div>
                <div className="col-md-4">
                    {props.timestamp > Date.now() ? <button id='btnBet' className="btn btn-info" onClick={handleMatchInfo}> BET </button> : 
                    <button className="btn btn-info" disabled> MATCH IS OVER </button>}
                </div>
                <div className="col-md-4">
                    <img src={props.logoVisitorTeam} alt="football_team_vistor" width="60" height="60" />
                </div>
            </div>
            {matchInfoIsOpen ?
                <MatchInfo
                    id={props.id}
                    teams={props.teams}
                    localTeamId={props.localTeamId}
                    localTeam={props.localTeam}
                    visitorTeam={props.visitorTeam}
                    visitorTeamId={props.visitorTeamId}
                    logoLocalTeam={props.logoLocalTeam}
                    logoVisitorTeam={props.logoVisitorTeam}
                    dateAndTime={props.dateAndTime}
                    date={props.date}
                    time={props.time}
                    timestamp={props.timestamp}
                    league={props.league}
                    onCancel={hadleCloseMatchInfo}
                    predictionLocal={props.predictionLocal}
                    predictionVisitor={props.predictionVisitor}
                    predictionDraw={props.predictionDraw}
                    winnerTeamId={props.winnerTeamId}
                    isProcessed= {props.isProcessed}
                /> : null}
            {matchInfoIsOpen ? <Backdrop onCancel={hadleCloseMatchInfo} /> : null}
        </div>
    );
}

export default Match;